import React from "react";
import { signIn } from "../../../../../shared/config/utils";
import Icon from "../../../../core-components/IconsSelector";
import * as S from "./OffersComponent.styles";
import { CTA_TYPE, getActionNameForOmniture, pushOmniEvents } from "../../../../../shared/utils/omni-utils";
import { gcBookingReviewScreen, getCtaProperty, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { CABS_REVIEW_ROUTE, APPLY, OFFER_SELECTED, OFFERS_COMPONENT, OFFER_REMOVED, LOGIN_NOW } from "../../../../../shared/utils/util-constants";
interface IOffers {
  offers: Array<Istate>;
  updateSelectedData: Function;
  promocode: string;
  Message: string;
  Code: string;
  isLoggedIn: boolean;
  Applied: boolean;
  preAppliedPromo: string;
}
interface Istate {
  title: string;
  code: string;
  subtitle: string;
}

enum EVENT_TYPE {
  PROMO_CODE  = "PROMO_CODE",
  OFFER       = "OFFER"
}

const OffersComponent: React.FC<IOffers> = ({
  offers = [],
  updateSelectedData = () => {},
  promocode = "",
  Message = "",
  Code = "",
  isLoggedIn = false,
  Applied = false,
  preAppliedPromo = ''
}) => {
  const inputRef = React.createRef();

  const sendOmniEvent = (code : string = "", eventType : EVENT_TYPE) => {
    const name : string   = eventType === EVENT_TYPE.PROMO_CODE ? APPLY : `${OFFER_SELECTED}_${code}`
    const type : CTA_TYPE = eventType === EVENT_TYPE.PROMO_CODE ?  CTA_TYPE.BUTTON : CTA_TYPE.RADIO_BUTTON
    const eventDetails = {
      cta: getCtaProperty(getActionNameForOmniture(gcBookingReviewScreen, name), type, OFFERS_COMPONENT, CABS_REVIEW_ROUTE)
    }

    if (eventType === EVENT_TYPE.PROMO_CODE) {
      eventDetails['booking'] = {
        promocode : code
     }
    } else {
      eventDetails['booking'] = {
        offerId : code
      }
    }

    pushOmniEvents({eventName: eventType === EVENT_TYPE.PROMO_CODE ? "applyPromocode" : "selectOffer", details: eventDetails})
  }
  return (
    <S.OffersComponentWrap>
      <div className="offersCmp_hdng">Offers</div>
      <div className="offersCmp_cont">
        {!isLoggedIn ? (
          <S.Strip>
            <Icon
              name="GOIcon"
              styleProps={{
                width: "1.9rem",
                margin: "0 1.5rem 0 0",
              }}
            />
            <a onClick={() => {
              pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, LOGIN_NOW), CTA_TYPE.HYPER_LINK, OFFERS_COMPONENT, CABS_REVIEW_ROUTE)
              signIn()
            }}> 
              Sign in and use your goCash 
            </a>
          </S.Strip>
        ) : null}
        <div className="appendTop10">
          {offers?.map(({ title, code, subtitle }, index) => {
            return (
              <div className="offrBox makeFlex hrtlCenter" key={`offers${index}`}>
                <S.SelectRadio
                  onChange={() => {
                    sendOmniEvent(code, EVENT_TYPE.OFFER)
                    updateSelectedData({ promocode: code })}
                  }
                >
                  <input
                    type="radio"
                    name="offers"
                    id={`offers${index}`}
                    checked={!!(Code === code)}
                  />
                  <label
                    htmlFor={`offers${index}`}
                    className="font16Global fontMedium"
                  >
                    {title}
                  </label>
                  {!!subtitle && <span
                    className="font12 lineHeight16 lightGrey appendTop4 appendLeft28"
                    style={promocode === code ? { color: "#2bac36" } : {}}
                  >
                    {subtitle}
                  </span>}
                </S.SelectRadio>
                {Code === code ? (
                  <S.Applied
                    onClick={() => {
                      pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, OFFER_REMOVED), CTA_TYPE.HYPER_LINK, OFFERS_COMPONENT, CABS_REVIEW_ROUTE)
                      updateSelectedData({ promocode: "" })
                    }}
                  >
                    <S.AppliedText>APPLIED</S.AppliedText>
                    <Icon
                      name="CloseIcon"
                      styleProps={{
                        width: "1.9rem",
                        fill: "#2bac36",
                        padding: "0.2rem 0rem 0rem 0rem",
                      }}
                    />
                  </S.Applied>
                ) : null}
              </div>
            );
          }) || null}
          <div className="offrBox">
            <div className="offrBox__hdng">
              <Icon name="Promocode" styleProps={{ padding: '0.3rem 0 0' }} />
              <label className="font16Global fontMedium appendLeft10">ENTER PROMO CODE</label>
            </div>
            <div style={{ position: "relative" }}>
              <input
                placeholder="Got A Promocode? Enter"
                ref={inputRef}
                style={{ color: "black" }}
              />
              {Message && Code !== preAppliedPromo ? <S.OfferError style={Applied ? { color: '#2bac36' } : {}}>{Message}</S.OfferError> : null}
              <S.Submit
                onClick={() => {
                  sendOmniEvent(inputRef.current.value, EVENT_TYPE.PROMO_CODE)
                  updateSelectedData({ promocode: inputRef.current.value })
                }}
              >
                <Icon
                  name="ArrowRightIcon"
                  styleProps={{
                    width: "1.4rem",
                    height: "1.4rem",
                    margin: "0 0 0 0",
                  }}
                />
              </S.Submit>
            </div>
          </div>
        </div>
      </div>
    </S.OffersComponentWrap>
  );
};

export default OffersComponent;
